import React from "react";
import ExpertiseBgLanding from "./ExpertiseBgLanding";
import OurExpertiseHeading from "./OurExpertiseHeading";
import ExpertiseCardSection from "./ExpertiseCardSection";
import { Box } from "@mui/material";
import CardImage01 from "../../assets/images/Expertise01Image.png";
import { Helmet } from "react-helmet";

const Expertise = () => {
  return (
    <>
      <Helmet>
        <title>Inteliphyle | Our Solutions</title>
        <meta
          name="description"
          content="Our solutions empower businesses to make informed decisions, optimize operations, and uncover new opportunities."
        />
      </Helmet>
      <Box
        sx={{
          backgroundColor: "#ecebeb",
        }}
      >
        <ExpertiseBgLanding />
        <OurExpertiseHeading />
        <ExpertiseCardSection CardImage01={CardImage01} />
      </Box>
    </>
  );
};

export default Expertise;
